import React from 'react';
import './header.css';
import CTA from './CTA';
import ME from '../../assets/avatar-bg.png';
import HeaderSocials from './HeaderSocials';

const Header = ({ setActiveNav }) => {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>Hello I'm </h5>
        <h1>Vitalii Kretsul</h1>
        <h5 className="text-light">Full-stack Web Developer</h5>
        <CTA setActiveNav={setActiveNav} />
        <HeaderSocials />
        <div className="me">
          <img src={ME} alt="me" />
        </div>
        <a
          href="#contact"
          className="scroll__down"
          onClick={() => setActiveNav('#contact')}
        >
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
